import { useEffect } from 'react';
import Navbar from './components/NavBar/Navbar.jsx';
import CookieBanner from './components/CookieBanner/CookieBanner.jsx';
import { getConsent, loadAnalyticsScripts } from './utils/cookieConsent';

function App() {
  useEffect(() => {
    if (getConsent() === 'all') {
      loadAnalyticsScripts();
    }
  }, []);

  return (
    <div className="container">
      <Navbar />
      <CookieBanner />
    </div>
  );
}

export default App;
